export const Icon = {
  functional: true,
  props: {
    name: {
      type: String,
      required: true, // e.g. "dropdown" | "upload"
    },
    color: {
      type: String,
      default: "#595959",
    },
    width: {
      type: [String, Number],
      default: 18,
    },
    height: {
      type: [String, Number],
      default: 18,
    },
    upColor: { type: String, default: null }, // specific color for up arrow
    downColor: { type: String, default: null },
  },
  render(h, ctx) {
    const { name, color, width, height, upColor, downColor } = ctx.props;

    const icons = {
      dropdown: {
        viewBox: "0 0 10 12",
        paths: [
          // Up arrow (left)
          h("path", {
            attrs: {
              d: "M4.2 3.2L2.8 1.8L1.4 3.2",
              stroke: upColor || color, // use upColor if provided
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": 1.5,
            },
          }),
          h("path", {
            attrs: {
              d: "M2.8 10.4V1.6",
              stroke: upColor || color,
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": 1.2,
            },
          }),

          // Down arrow (right)
          h("path", {
            attrs: {
              d: "M5.8 8.7L7.2 10.1L8.6 8.7",
              stroke: downColor || color, // use downColor if provided
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": 1.5,
            },
          }),
          h("path", {
            attrs: {
              d: "M7.2 1.6V10.4",
              stroke: downColor || color,
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": 1.2,
            },
          }),
        ],
      },

      download: {
        viewBox: "2 2 14 14", // tight viewBox matching path bounds
        paths: [
          h("path", {
            attrs: {
              d: "M9.37167 12.0256C9.27628 12.1299 9.14148 12.1893 9.00009 12.1893C8.85871 12.1893 8.72391 12.1299 8.62851 12.0256L5.94319 9.08854C5.75555 8.88332 5.76981 8.56484 5.97503 8.3772C6.18027 8.18957 6.49874 8.2038 6.68637 8.40903L8.4966 10.389V2.95857C8.4966 2.6805 8.72203 2.45508 9.00009 2.45508C9.27816 2.45508 9.50359 2.6805 9.50359 2.95857V10.389L11.3138 8.40903C11.5015 8.2038 11.8199 8.18957 12.0252 8.3772C12.2304 8.56484 12.2446 8.88332 12.057 9.08854L9.37167 12.0256Z",
              fill: color,
            },
          }),
          h("path", {
            attrs: {
              d: "M3.46171 11.0152C3.46171 10.7372 3.23629 10.5117 2.95821 10.5117C2.68014 10.5117 2.45471 10.7372 2.45471 11.0152V11.0521C2.4547 11.9702 2.45469 12.7102 2.53294 13.2922C2.61418 13.8965 2.78798 14.4052 3.19207 14.8093C3.59615 15.2134 4.10493 15.3872 4.7092 15.4685C5.29122 15.5467 6.03124 15.5467 6.94935 15.5467H11.051C11.9691 15.5467 12.7091 15.5467 13.2912 15.4685C13.8954 15.3872 14.4042 15.2134 14.8083 14.8093C15.2124 14.4052 15.3862 13.8965 15.4674 13.2922C15.5456 12.7102 15.5456 11.9702 15.5456 11.0521V11.0152C15.5456 10.7372 15.3202 10.5117 15.0421 10.5117C14.7641 10.5117 14.5386 10.7372 14.5386 11.0152C14.5386 11.9788 14.5376 12.6509 14.4694 13.158C14.4032 13.6507 14.282 13.9115 14.0962 14.0973C13.9104 14.2831 13.6496 14.4042 13.157 14.4705C12.6498 14.5386 11.9778 14.5397 11.0142 14.5397H6.98618C6.02255 14.5397 5.35047 14.5386 4.84338 14.4705C4.35078 14.4042 4.08991 14.2831 3.90412 14.0973C3.71832 13.9115 3.59718 13.6507 3.53095 13.158C3.46277 12.6509 3.46171 11.9788 3.46171 11.0152Z",
              fill: color,
            },
          }),
        ],
      },
      arrowUp: {
        viewBox: "0 0 12 12",
        paths: [
          // Up arrow
          h("path", {
            attrs: {
              d: "M5.45449 3.27308L3.81813 1.63672L2.18176 3.27308",
              stroke: color,
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          // Vertical line
          h("path", {
            attrs: {
              d: "M3.81812 10.364V1.63672",
              stroke: color,
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
        ],
      },

      arrowDown: {
        viewBox: "0 0 12 12",
        paths: [
          // Down arrow
          h("path", {
            attrs: {
              d: "M6.54541 8.72656L8.18177 10.3629L9.81814 8.72656",
              stroke: color,
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          // Vertical line
          h("path", {
            attrs: {
              d: "M8.18175 1.63672V10.364",
              stroke: color,
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
        ],
      },
    };

    const icon = icons[name] || { viewBox: "0 0 18 18", paths: [] };
    return h(
      "svg",
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width,
          height,
          viewBox: icon.viewBox,
          fill: "none",
        },
      },
      icon.paths
    );
  },
};
